import { css } from "@emotion/react";

export const skeletonButton = css`
  margin-bottom: 1rem;
`;

export const trayColumnItemSkeleton = css`
  &&& {
    margin-bottom: 0;
  }
`;
